import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { ContractsEmptyStateIllustration } from "@dreamhub/designsystem/icons";

interface Props {
  companyName?: string;
  title: string;
  subtitle: string;
  children?: React.ReactNode;
}

const CommercialsEmptyState: React.FC<Props> = ({
  companyName,
  title,
  subtitle,
  children
}) => {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full h-full items-center justify-center">
      <div className="flex items-center gap-16">
        <ContractsEmptyStateIllustration />
        <div className="flex flex-col gap-10 w-[20rem]">
          <div className="flex flex-col gap-6">
            <Text variant="lgLabel">{`${companyName} ${t(title)}`}</Text>
            <Text variant="bodySecondary">{t(subtitle)}</Text>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CommercialsEmptyState;
